export interface Pagination {
  pageLimit: number;
  pageOffset?: number;
}

export interface Sort {
  columnName: string;
  order: string;
}

export interface Filter {
  column_name: string;
  filter_type: string;
  values: string[];
}

export interface GetItemsRequest {
  readonly pagination?: Pagination;
  readonly filters?: Filter[];
  readonly sort?: Sort;
  readonly nextToken?: string;
}

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

export enum Tag {
  SUBSCRIPTIONS = 'Subscriptions',
  REPORTS = 'Reports',
  REPORT_METADATA = 'ReportMetadata',
  ADVERTISERS = 'Advertisers',
  USER_PREFERENCES = 'UserPreferences',
  COUNTRIES = 'Countries',
  ACCOUNTS = 'Accounts',
  CAMPAIGNS = 'Campaigns',
  TEMPLATES = 'Templates',
  METADATA = 'Metadata',
  FLEXIBLE_SUBSCRIPTIONS = 'FlexibleSubscriptions',
  FLEXIBLE_REPORTS = 'FlexibleReports'
}
